import {NewsError} from './NewsError.js'

export class GetVehicleNewsError extends NewsError {}
